import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from './FormDropdown'
import { status_aktif } from '../constants/general'

const tingkat_kelas = []

for (let i=0; i<=11; i++) {
    tingkat_kelas[i] = {
        key     : i + 1,
        value   : i + 1
    }
}

class AddMapelModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mapel_id        : "",
            mapel_nama      : "",
            mapel_status    : "1",
            isButtonLoading : false,
            isLoading       : false,
            dataShift       : [],
            isModalShow         : false
        };


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleToggleMapel = this.handleToggleMapel.bind(this);
    }

    handleToggleMapel() {
        this.props.toggleModalMapel()
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handleSubmit() {

        this.setState({isButtonLoading: true})

        const url = "mapel/add";

        axios({
            method: 'post',
            url: url,
            data: qs.stringify(this.state)
        })
            .then(response => {

                const result = response.data;

                if (result.success) {

                    Alert.success(result.message)
                    window.location.reload();
                }
                else {

                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isButtonLoading: false })
                }
            })
            .catch(error => {

                console.log(error)
                this.setState({isButtonLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })

    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggleMapel} className="modal-primary">
                <ModalHeader toggle={this.handleToggleMapel}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div className="col-sm-12">
                        <div className="card" >
                            <div className="card-header">Mata Pelajaran</div>
                            <div className="card-block">
                                {
                                    this.state.isLoading ? 'Memuat Data...' : (
                                        <div className="form-horizontal animated fadeIn">
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Nama Mapel</label>
                                                <div className="col-md-10">
                                                    <input
                                                        name="mapel_nama"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nama Mata Pelajaran"
                                                        onChange={this.handleChange}
                                                        value={this.state.mapel_nama} />
                                                </div>
                                            </div>
                                            {/*<div className="form-group row">*/}
                                            {/*    <label className="col-md-2 form-control-label">Status Aktif</label>*/}
                                            {/*    <div className="col-md-10">*/}
                                            {/*        <FormDropdown*/}
                                            {/*            items={status_aktif}*/}
                                            {/*            onChange={this.handleChange}*/}
                                            {/*            value={this.state.mapel_status}*/}
                                            {/*            name="mapel_status"*/}
                                            {/*        />*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-md btn-primary"
                        disabled={this.state.isButtonLoading && "disabled"}
                        onClick={this.handleSubmit}
                    >
                        {this.state.isButtonLoading ? "Loading" : "Simpan"}
                    </button>{" "}
                    <button
                        type="button"
                        className="btn btn-md btn-danger"
                        disabled={this.state.isButtonLoading && "disabled"}
                        onClick={this.handleToggleKelas}
                    >
                        Batal
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

AddMapelModal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    /*handleSubmit: PropTypes.func.isRequired,*/
    toggleModalKelas: PropTypes.func.isRequired,
}

export default AddMapelModal


// WEBPACK FOOTER //
// ./src/components/AddMapelModal.js